import { createAction, props } from "@ngrx/store";
import { EditAdministrator } from "src/app/_models/Administrator";
import { UserEmail, Userprofile } from "src/app/_models/Userprofile";
import { EditAdministratorActionTypes } from "src/app/constants/StoreConstants";

export const GetAdmin = createAction(
  EditAdministratorActionTypes.GetAdmin,
  props<{ id: number }>()
);
export const GetAdminSuccess = createAction(
  EditAdministratorActionTypes.GetAdminSuccess,
  props<{ userProfile: Userprofile; emailList: UserEmail[] }>()
);
export const GetAdminError = createAction(
  EditAdministratorActionTypes.GetAdminError,
  props<{ error: any }>()
);
export const UpdateAdmin = createAction(
  EditAdministratorActionTypes.EditAdmin,
  props<{ adminId: number; admin: EditAdministrator }>()
);
export const UpdateAdminSuccess = createAction(
  EditAdministratorActionTypes.EditAdminSuccess,
  props<{ updatedAdmin: Userprofile }>()
);
export const UpdateAdminError = createAction(
  EditAdministratorActionTypes.EditAdminError,
  props<{ error: any }>()
);
export const ClearEditAdministratorState = createAction(
  EditAdministratorActionTypes.ClearEditAdministratorState
);
